import { connect } from 'react-redux';
import { createMatchSelector } from 'connected-react-router';
import { pipe, path, equals } from 'ramda';
import { ifElseWithI18n } from 'utilities/ramda';

import MedicalTherapyInfo from 'components/MedicalTherapyInfo';
import {
  getReportItemReviewedDateTime,
  getReportItemMedicalTherapyStatus,
} from 'store/selectors/reports/singleItems';
import {
  getPatientClinicPhone,
  getPatientClinicName,
} from 'store/selectors/patientQuestionnaireResponse';
import { getUserRole } from 'store/selectors/user';

const getPatientNoteByStatus = ifElseWithI18n(
  equals('success'),
  'reports.patientMedicalTherapy.greenStatus',
  'reports.patientMedicalTherapy.redStatus',
);

const mapStateToProps = state => {
  const observationId = pipe(
    createMatchSelector('/report/:observationId'),
    path(['params', 'observationId']),
  )(state);
  const status = getReportItemMedicalTherapyStatus(observationId)(state);

  return {
    clinicName: getPatientClinicName(state),
    role: getUserRole(state),
    clinicPhone: getPatientClinicPhone(state),
    notes: getPatientNoteByStatus(status),
    reviewedDateTime: getReportItemReviewedDateTime(observationId)(state),
    status,
  };
};

export default connect(mapStateToProps)(MedicalTherapyInfo);
